module.exports = __webpack_public_path__ + "img/step4-fr.4800c42e.webp";